import React from "react";

interface Props {}

const Loading = (props: Props) => {
  return <div>Loading</div>;
};

export default Loading;
